export default "__VITE_ASSET__Czp9BGt$__"